export default __webpack_public_path__ + "static/media/GREEN_RIGHT_TICK.bcaaf321.svg";